<form
  *ngIf="(state$ | async)?.form as form"
  [formGroup]="form"
  class="form">
  <mat-form-field>
    <input
      matInput
      formControlName="codiceUnico"
      [placeholder]="'Codice Unico' | translate">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      formControlName="SGT.SGTT"
      [placeholder]="'SGTT' | translate">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      formControlName="MTC"
      [placeholder]="'MTC' | translate">
  </mat-form-field>
  <div class="numeric-range-filter">
    <mat-form-field appearance="fill">
      <mat-label>Range Altezza</mat-label>
      <mat-select formControlName="height" multiple>
        <mat-option value="0-50">0-50 cm</mat-option>
        <mat-option value="50-100">50-100 cm</mat-option>
        <mat-option value="100-150">100-150 cm</mat-option>
        <mat-option value="150-200">150-200 cm</mat-option>
        <mat-option value="200-250">200-250 cm</mat-option>
        <mat-option value="250">250+ cm</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="numeric-range-filter">
    <mat-form-field appearance="fill">
      <mat-label>Range Larghezza</mat-label>
      <mat-select formControlName="width" multiple>
        <mat-option value="0-50">0-50 cm</mat-option>
        <mat-option value="50-100">50-100 cm</mat-option>
        <mat-option value="100-150">100-150 cm</mat-option>
        <mat-option value="150-200">150-200 cm</mat-option>
        <mat-option value="200-250">200-250 cm</mat-option>
        <mat-option value="250">250+ cm</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="numeric-range-filter">
    <mat-form-field appearance="fill">
      <mat-label>Range Profondità</mat-label>
      <mat-select formControlName="depth" multiple>
        <mat-option value="0-50">0-50 cm</mat-option>
        <mat-option value="50-100">50-100 cm</mat-option>
        <mat-option value="100-150">100-150 cm</mat-option>
        <mat-option value="150-200">150-200 cm</mat-option>
        <mat-option value="200-250">200-250 cm</mat-option>
        <mat-option value="250">250+ cm</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

</form>
